import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, BookOpen } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { GUIDES } from "@/constants/site";

export default function GuidesSection() {
  return (
    <section id="guides" className="bg-[#FAFAFA] py-20 sm:py-28" data-testid="guides-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="06"
          caption="Free Expert Advice"
          title="Repair Guides From Our Technicians."
          sub="Real answers to the problems we fix every day — check these before you spend anything."
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {GUIDES.map((guide, i) => (
            <motion.div
              key={guide.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 4) * 0.08 }}
            >
              <Link
                to={`/guides/${guide.slug}`}
                data-testid={`guide-card-${guide.slug}`}
                className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:border-rescue/40 hover:shadow-xl hover:shadow-red-600/5"
              >
                <BookOpen className="h-6 w-6 text-rescue" />
                <h3 className="mt-4 flex-1 font-display text-lg font-bold leading-snug text-navy">
                  {guide.title}
                </h3>
                <div className="mt-5 flex items-center justify-between">
                  <span className="flex items-center gap-1.5 font-mono text-[10px] font-bold uppercase tracking-wider text-slate-400">
                    <Clock className="h-3 w-3" /> {guide.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-sm font-bold text-rescue">
                    Read
                    <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
